<template>
  <v-container class="fill-height">
    <v-row style="width: 100%;">
        <v-col cols="12">
            <div v-if="!galleryFiles.length">No photos added</div>
            <v-card v-else>
                <v-container fluid>
                    <v-row>
                        <v-col
                            v-for="galleryFile in galleryFiles"
                            :key="galleryFile.id"
                            class="d-flex child-flex"
                            cols="2"
                        >
                            <v-card flat tile class="d-flex">
                                <v-btn @click="handleDeleteButtonClick(galleryFile.id)" class="gallery-image-delete" depressed small color="error">Delete</v-btn>
                                <v-img
                                :src="galleryFile.image"
                                aspect-ratio="1"
                                class="grey lighten-2"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                        >
                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-col>
        <v-btn @click="uploadForm = true" class="mx-2 addGalleryImageButton" fab dark color="indigo">
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>
    </v-row>
    <v-dialog
        v-model="uploadForm"
        max-width="700px"
      >
        <v-card>
          <v-card-title>
            <span>Upload image</span>
          </v-card-title>
          <v-card-text>
              <v-file-input
                accept="image/*"
                v-model="images"
                color="deep-purple accent-4"
                counter
                multiple
                placeholder="Select your images"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
            >
                <template v-slot:selection="{ index, text }">
                    <v-chip
                        v-if="index < 2"
                        color="deep-purple accent-4"
                        dark
                        label
                        small
                    >
                        {{ text }}
                    </v-chip>

                    <span
                        v-else-if="index === 2"
                        class="overline grey--text text--darken-3 mx-2"
                    >
                        +{{ images.length - 2 }} File(s)
                    </span>
                </template>
            </v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="uploadForm = false"
            >
              Close
            </v-btn>
            <v-btn @click="handleUploadClick" :disabled="!images.length" color="primary">
              Upload
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import { deleteGalleryFile, uploadGallery } from '@/repositories/upload.repository'

export default {
    data () {
        return {
            uploadForm: false,
            images: []
        }
    },
    created () {
        this.$store.dispatch('getGalleryFiles')
    },
    computed: {
        galleryFiles () {
            return this.$store.state.gallery.galleryFiles
        }
    },
    methods: {
        handleDeleteButtonClick (id) {
            deleteGalleryFile(id).then(() => {
                this.$store.dispatch('getGalleryFiles')
            })
        },
        handleUploadClick () {
            if (this.images.length) {
                const formData = new FormData()
                this.images.forEach(image => {
                    formData.append('images', image)
                })

                try {
                    uploadGallery(formData).then(() => {
                        this.images = []
                        this.$store.dispatch('getGalleryFiles')
                    }).catch((e) => {
                        console.log(e)
                    })
                } catch (e) {
                    console.log(e)
                }

                this.uploadForm = false
            }
        }
    }
}
</script>

<style lang="scss">
.gallery-image-delete {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
}
.addGalleryImageButton {
    position: absolute;
    right: 50px;
    bottom: 50px;
}
</style>